module.exports = __webpack_public_path__ + "img/bsyd-banner1.6486ad9f.png";